/** Undo the double/triple HTML-encoding in JD text and collapse stray line breaks. */
export function cleanText(value: string | null | undefined): string {
  if (value == null) return '';
  let t = String(value);
  for (let i = 0; i < 3 && t.includes('&amp;'); i++) t = t.replace(/&amp;/g, '&');
  return t
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s*\n\s*/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

export function plural(n: number, one: string, many: string = one + 's'): string {
  return n + ' ' + (n === 1 ? one : many);
}

export function joinList(items: string[]): string {
  if (items.length <= 1) return items[0] ?? '';
  return items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
}

export function lowerFirst(s: string): string {
  return s ? s.charAt(0).toLowerCase() + s.slice(1) : s;
}

export function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

/** Empty rather than the words "Invalid Date", which is what an unparseable value formats as. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  return Number.isNaN(new Date(iso).getTime()) ? '' : formatDate(iso) + ', ' + formatTime(iso);
}

export function formatPoints(n: number): string {
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}

export function errorMessage(e: unknown, fallback: string): string {
  return e instanceof Error && e.message ? e.message : fallback;
}

const NAME_NOISE = /\b(resume|resumé|cv|profile|final|updated|v\d+)\b/gi;

/**
 * A first guess at the candidate's name from their file name, for the recruiter to correct.
 * Only ever a pre-fill: the contract requires a real name and nothing recovers it later.
 */
export function nameFromFileName(fileName: string): string {
  return fileName
    .replace(/\.[^.]+$/, '')
    .replace(/[_\-.]+/g, ' ')
    .replace(NAME_NOISE, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
